import Mime from 'mime'

export const getFileDescriptionByMimeType = (mimeType: string): string => {
    const extension = Mime.getExtension(mimeType)
    switch (extension) {
        case 'aac':
            return 'Advanced Audio Coding'
        case 'ai':
            return 'Adobe Illustrator'
        case 'bmp':
            return 'Bitmap Image File'
        case 'cdr':
            return 'Vector Graphics File'
        case 'doc':
        case 'docx':
            return 'Microsoft Word'
        case 'eps':
            return 'Encapsulated Postscript'
        case 'gif':
            return 'Graphics Interchange Format'
        case 'jpg':
        case 'png':
            return 'Image File'
        case 'mkv':
            return 'Matroska Video'
        case 'mov':
            return 'QuickTime Movie Format'
        case 'mp3':
            return 'MPEG + Audio Layer-3'
        case 'mpg':
        case 'mpeg':
            return 'Moving Pictures Expert Group'
        case 'pdf':
            return 'Portable Document Format'
        case 'ppt':
        case 'pptx':
            return 'Microsoft PowerPoint'
        case 'ps':
            return 'Adobe Postscript'
        case 'psd':
            return 'Adobe Photoshop'
        case 'svg':
            return 'Scalable Vector Graphics'
        case 'trf':
            return 'Rich Text Format Document'
        case 'txt':
            return 'Text File'
        case 'wma':
            return 'Windows Media'
        case 'xls':
        case 'xlsx':
            return 'Microsoft Excel'
        case 'zip':
            return 'Zipped File'
        case 'sql':
            return 'Structured Query Language'
        default:
            return 'Undefined File'
    }
}